/**
 * Created by stonewang on 2017/8/24.
 */
import Reflux from 'reflux';
/**
 * 1、Store 和 Actions 的名称需要保持一致。要求这两个词的前缀或后缀相同。
 * 2、createActions接收的参数要和Store中的方法保持一致
 */
export const Actions = Reflux.createActions([
  'paramChange',
  'useStoreChange',
]);

export class Store extends Reflux.Store {
  constructor()
  {
    super();
    this.state = {
      useHouseStore: false,
      useInventoryStore: false,
      useNotReachStore: false,
      useRecordStore: false,
      useEntryStore: false,
      inventoryIndex: '',
      notReachIndex: '',
      recordIndex: '',
      entryIndex: '',
      houseParams: {
        s: 10,
        p: 1,
      },
      inventoryParams: {
        s: 10,
        p: 1,
      },
      notReachParams: {
        s: 10,
        p: 1,
      },
      recordParams: {
        s: 10,
        p: 1,
      },
      entryParams: {
        s: 10,
        p: 1,
      }
    };
    this.listenables = Actions;
  }
  useStoreChange(data){
    this.setState({
      ...this.state,
      ...data
    });
  }
  paramChange(key, data){
    this.setState({
      ...this.state,
      [key]:{
        ...this.state[key],
        ...data
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/routes/inventory/store.js